var map = {
	"./button.mp3": "cfd2",
	"./cancel.mp3": "871c",
	"./cloud.mp3": "6036",
	"./failure.mp3": "2f7a",
	"./medal-gold.mp3": "97fb",
	"./medal.mp3": "06a3",
	"./pop.mp3": "f540",
	"./result.mp3": "8615",
	"./success.mp3": "1ef2",
	"./unlock-city.mp3": "ed73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44e0";